import { createApp } from "vue";
import App from "./App.vue";
import { createWebHistory, createRouter } from "vue-router";
import HomePages from "@/components/HomePages.vue";
import KatalogPages from "@/components/KatalogPages.vue";
import ContactsPages from "@/components/ContactsPages.vue";
import DeliveryPages from "@/components/DeliveryPages.vue";
import NewsPages from "@/components/NewsPages.vue";
import ArticlePages from "@/components/ArticlePages.vue";
import GoodsPages from "@/components/GoodsPages.vue";
import TestPages from "@/components/TestPages.vue";
import GoodsPagesgrape from "@/components/goods/GoodsPagesgrape.vue";
import GoodsPageslush from "@/components/goods/GoodsPageslush.vue";
import GoodsPageskiwi from "@/components/goods/GoodsPageskiwi.vue";
import GoodsPagescola from "@/components/goods/GoodsPagescola.vue";
import GoodsPagescherry from "@/components/goods/GoodsPagescherry.vue";
import GoodsPagesenergy from "@/components/goods/GoodsPagesenergy.vue";
import GoodsPagesraspberry from "@/components/goods/GoodsPagesraspberry.vue";
import GoodsPagesmixed from "@/components/goods/GoodsPagesmixed.vue";
import GoodsPagesblackcurrant from "@/components/goods/GoodsPagesblackcurrant.vue";
import GoodsPagesbanana6 from "@/components/goodsjijki6/GoodsPagesbanana6.vue";
import GoodsPagesblueberries6 from "@/components/goodsjijki6/GoodsPagesblueberries6.vue";
import GoodsPagescherrylime6 from "@/components/goodsjijki6/GoodsPagescherrylime6.vue";
import GoodsPagesforest6 from "@/components/goodsjijki6/GoodsPagesforest6.vue";
import GoodsPagesgrape6 from "@/components/goodsjijki6/GoodsPagesgrape6.vue";
import GoodsPageswatermelon6 from "@/components/goodsjijki6/GoodsPageswatermelon6.vue";
import GoodsPagesicecream6 from "@/components/goodsjijki6/GoodsPagesicecream6.vue";
import GoodsPagesmango6 from "@/components/goodsjijki6/GoodsPagesmango6.vue";
import GoodsPagespeach6 from "@/components/goodsjijki6/GoodsPagespeach6.vue";
import GoodsPagespineapple6 from "@/components/goodsjijki6/GoodsPagespineapple6.vue";
import GoodsPagespink6 from "@/components/goodsjijki6/GoodsPagespink6.vue";
import GoodsPagesblueberriesrasb6 from "@/components/goodsjijki6/GoodsPagesblueberriesrasb6.vue";
import GoodsPagesgumm6 from "@/components/goodsjijki6/GoodsPagesgumm6.vue";
import GoodsPagesbanana_milk2 from "@/components/goodsjijki2/GoodsPagesbanana_milk2.vue";
import GoodsPagesblueberries2 from "@/components/goodsjijki2/GoodsPagesblueberries2.vue";
import GoodsPagescoconut2 from "@/components/goodsjijki2/GoodsPagescoconut2.vue";
import GoodsPagescolalemon2 from "@/components/goodsjijki2/GoodsPagescolalemon2.vue";
import GoodsPagescream2 from "@/components/goodsjijki2/GoodsPagescream2.vue";
import GoodsPagesgreenapple2 from "@/components/goodsjijki2/GoodsPagesgreenapple2.vue";
import GoodsPagesgum2 from "@/components/goodsjijki2/GoodsPagesgum2.vue";
import GoodsPageslemonade2 from "@/components/goodsjijki2/GoodsPageslemonade2.vue";
import GoodsPagespeach2 from "@/components/goodsjijki2/GoodsPagespeach2.vue";
import GoodsPagesraspberry2 from "@/components/goodsjijki2/GoodsPagesraspberry2.vue";
import GoodsPagesraspberrygum2 from "@/components/goodsjijki2/GoodsPagesraspberrygum2.vue";
import GoodsPageswatermelon2 from "@/components/goodsjijki2/GoodsPageswatermelon2.vue";
import GoodsPageswildberries2 from "@/components/goodsjijki2/GoodsPageswildberries2.vue";
import GoodsPagesblueberries22 from "@/components/goodsjijki2/GoodsPagesblueberries22.vue";
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      name: "HomePages",
      path: "/",
      component: HomePages,
    },
    {
      name: "KatalogPages",
      path: "/katalog",
      component: KatalogPages,
    },
    {
      name: "ContactsPages",
      path: "/contacts",
      component: ContactsPages,
    },
    {
      name: "DeliveryPages",
      path: "/delivery",
      component: DeliveryPages,
    },
    {
      name: "NewsPages",
      path: "/news",
      component: NewsPages,
    },
    {
      name: "ArticlePages",
      path: "/article",
      component: ArticlePages,
    },
    {
      name: "GoodsPages",
      path: "/goods",
      component: GoodsPages,
    },
    {
      name: "GoodsPagesgrape",
      path: "/goodsgrape",
      component: GoodsPagesgrape,
    },
    {
      name: "GoodsPagescola",
      path: "/goodscola",
      component: GoodsPagescola,
    },
    {
      name: "GoodsPagescherry",
      path: "/goodscherry",
      component: GoodsPagescherry,
    },
    {
      name: "GoodsPageslush",
      path: "/goodslush",
      component: GoodsPageslush,
    },
    {
      name: "GoodsPageskiwi",
      path: "/goodskiwi",
      component: GoodsPageskiwi,
    },
    {
      name: "GoodsPagesenergy",
      path: "/goodsenergy",
      component: GoodsPagesenergy,
    },
    {
      name: "GoodsPagesraspberry",
      path: "/goodsraspberry",
      component: GoodsPagesraspberry,
    },
    {
      name: "GoodsPagesmixed",
      path: "/goodsmixed",
      component: GoodsPagesmixed,
    },
    {
      name: "GoodsPagesblackcurrant",
      path: "/goodsblackcurrant",
      component: GoodsPagesblackcurrant,
    },
    {
      name: "GoodsPagesbanana6",
      path: "/goodspagesbanana6",
      component: GoodsPagesbanana6,
    },
    {
      name: "GoodsPagesblueberries6",
      path: "/goodspagesblueberries6",
      component: GoodsPagesblueberries6,
    },
    {
      name: "GoodsPagescherrylime6",
      path: "/goodspagescherrylime6",
      component: GoodsPagescherrylime6,
    },
    {
      name: "GoodsPagesforest6",
      path: "/goodspagesforest6",
      component: GoodsPagesforest6,
    },
    {
      name: "GoodsPagesgrape6",
      path: "/goodspagesgrape6",
      component: GoodsPagesgrape6,
    },
    {
      name: "GoodsPageswatermelon6",
      path: "/goodspageswatermelon6",
      component: GoodsPageswatermelon6,
    },
    {
      name: "GoodsPagesicecream6",
      path: "/goodspagesicecream6",
      component: GoodsPagesicecream6,
    },
    {
      name: "GoodsPagesmango6",
      path: "/goodspagesmango6",
      component: GoodsPagesmango6,
    },
    {
      name: "GoodsPagespeach6",
      path: "/goodspagespeach6",
      component: GoodsPagespeach6,
    },
    {
      name: "GoodsPagespineapple6",
      path: "/goodspagespineapple6",
      component: GoodsPagespineapple6,
    },
    {
      name: "GoodsPagespink6",
      path: "/goodspagespink6",
      component: GoodsPagespink6,
    },
    {
      name: "GoodsPagesgumm6",
      path: "/goodspagesgumm6",
      component: GoodsPagesgumm6,
    },
    {
      name: "GoodsPagesbanana_milk2",
      path: "/goodspagesbanana_milk2",
      component: GoodsPagesbanana_milk2,
    },
    {
      name: "GoodsPagesblueberries2",
      path: "/goodspagesblueberries2",
      component: GoodsPagesblueberries2,
    },
    {
      name: "GoodsPagescoconut2",
      path: "/goodspagescoconut2",
      component: GoodsPagescoconut2,
    },
    {
      name: "GoodsPagescream2",
      path: "/goodspagescream2",
      component: GoodsPagescream2,
    },
    {
      name: "GoodsPagescolalemon2",
      path: "/goodspagescolalemon2",
      component: GoodsPagescolalemon2,
    },
    {
      name: "GoodsPagesgreenapple2",
      path: "/goodspagesgreenapple2",
      component: GoodsPagesgreenapple2,
    },
    {
      name: "GoodsPagesgum2",
      path: "/goodspagesgum2",
      component: GoodsPagesgum2,
    },
    {
      name: "GoodsPagespeach2",
      path: "/goodspagespeach2",
      component: GoodsPagespeach2,
    },
    {
      name: "GoodsPageslemonade2",
      path: "/goodspageslemonade2",
      component: GoodsPageslemonade2,
    },
    {
      name: "GoodsPagesraspberrygum2",
      path: "/goodspagesraspberrygum2",
      component: GoodsPagesraspberrygum2,
    },
    {
      name: "GoodsPagesraspberry2",
      path: "/goodspagesraspberry2",
      component: GoodsPagesraspberry2,
    },
    {
      name: "GoodsPageswatermelon2",
      path: "/goodspageswatermelon2",
      component: GoodsPageswatermelon2,
    },
    {
      name: "GoodsPageswildberries2",
      path: "/goodspageswildberries2",
      component: GoodsPageswildberries2,
    },
    {
      name: "GoodsPagesblueberries22",
      path: "/GoodsPagesblueberries22",
      component: GoodsPagesblueberries22,
    },
    {
      name: "GoodsPagesblueberriesrasb6",
      path: "/GoodsPagesblueberriesrasb6",
      component: GoodsPagesblueberriesrasb6,
    },
    {
      name: "TestPages",
      path: "/test",
      component: TestPages,
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // Если пользователь возвращается назад, прокручиваем к сохранённой позиции
      return savedPosition;
    } else {
      // Прокручиваем к началу страницы при переходе на новый маршрут
      return { top: 0 };
    }
  },
});

const app = createApp(App);
createApp(App);
app.use(router);
app.mount("#app");
